import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  serverMessage?: string;
}

export function ErrorDialog(props: Props) {
  return (
    <DialogConfirmation
      id="error-dialog"
      open={props.open}
      closeLabel={translate('Close')}
      {...props}
      title={translate('Something Went Wrong')}
      actions={[
        <UIButton key="ok" onClick={props.onClose}>
          {translate('Ok', true)}
        </UIButton>,
      ]}
    >
      {translate('Please try again or contact support for assistance.')}
      {props.serverMessage && (
        <p className="font-sans text-blue-600 my-4">{props.serverMessage}</p>
      )}
    </DialogConfirmation>
  );
}
